import { ConsoleRequest, DataProviderType } from '../../utils/request';
import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { LoggedInUserData } from '../addAccount/types';

export class LoggedInUserDataProvider extends BaseWebComponentDataProvider {
  async getLoggedInUserData(): Promise<LoggedInUserData> {
    const response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Users',
      method: 'getRecordFormInfo',
      payload: {
        companyId: null,
      },
    });

    return response.data;
  }
}
